export const analytics = {
  botWise: {
    botWiseAnalytics: 'Bot-Wise 分析',
    currentBillingCycle: '当前计费周期',
    currentMonth: '当前月份',
    sinceAccountCreation: '自创建账户以来',
    messages: '消息',
    leads: '潜在客户',
    noDataFound: {
      botwiseAnalytics: 'Bot-Wise 分析',
      noBotHasBeenCreatedYet: '尚未创建任何机器人！',
    },
    appTooltip: {
      TOOLTIP_BOTWISE_SUMMARY: '总结特定机器人在当前计费周期、当前月份或自账户创建以来的消息和联系/潜在客户数据（每天午夜更新一次）',
      TOOLTIP_FILTERS: '筛选选定机器人的数据',
      TOOLTIP_MESSAGES: '自账户创建以来由您的账户消耗的消息总数',
      TOOLTIP_LEADS: '自账户创建以来由机器人捕获的潜在客户总数',
    }
  },
  overview: {
    analytics: '分析',
    seeHowToUse: '了解如何使用',
    help: '帮助',
    overview: '概览',
    messages: '消息',
    leads: '潜在客户',
    appTooltip: {
      TOOLTIP_OVERVIEW_TITLE: '所有机器人消息和潜在客户的分析。（每天午夜更新一次）',
    }
  },
  summary: {
    analyticsSummary: '分析摘要',
    allBots: '所有机器人',
    daily: '每天',
    weekly: '每周',
    monthly: '每月',
    messages: '消息',
    leads: '潜在客户',
    appTooltip: {
      TOOLTIP_ANALYTICS_SUMMARY: '总结特定和所有机器人的每日、每周或每月消息和联系/潜在客户数据（每天午夜更新一次）',
    }
  },
  whatsapp: {
    analyticsCount: {
      whatsappAnalytics: 'WhatsApp 分析',
      month: '月份',
      week: '周',
      today: '今天',
      filters: '筛选器',
      clearAll: '清除所有',
      apply: '应用',
      totalConversations: '总对话',
      freeConversations: '免费对话',
      paidConversations: '付费对话',
      messageSent: '消息已发送',
      messageDelivered: '消息已送达',
      bpDropDown: {
        selectBot: '选择机器人',
      },
      indexMergeDatePicker: {
        startDate: '开始日期',
        endDate: '结束日期',
      }
    },
    conversationAnalytics: {
      conversationAnalytics: '对话分析',
      month: '月份',
      week: '周',
      today: '今天',
      totalConversations: '总对话',
      paidConversations: '付费对话',
      freeConversations: '免费对话',
      indexMergeDatePicker: {
        startDate: '开始日期',
        endDate: '结束日期',
      },
      bpDropDown: {
        allBots: '所有机器人'
      }
    },
    messageAnalytics: {
      whatsappMessages: 'WhatsApp 消息',
      sent: '已发送',
      delivered: '已送达',
      indexMergeDatePicker: {
        startDate: '开始日期',
        endDate: '结束日期',
      },
      bpDropDown: {
        allBots: '所有机器人'
      },
      month: '月份',
      week: '周',
      today: '今天',
    },
    messageStatusAnalytics: {
      whatsappMessagesByStatus: 'WhatsApp 消息状态分析',
      sent: '已发送',
      delivered: '已送达',
      indexMergeDatePicker: {
        startDate: '开始日期',
        endDate: '结束日期',
      },
      bpDropDown: {
        allBots: '所有机器人'
      },
      month: '月份',
      week: '周',
      today: '今天',
    },
    newWhatsappAnalytics: {
      allSubscribers: '所有订阅者',
      whatsappSubscribers: 'WhatsApp 订阅者'
    }
  }
};
